import moment from 'moment';

const FORMAT_KEY = 'DD_MM_YY';

export const DOWNTIME_BANNER_KEY = 'loomDowntimeBanner';

export const DAILY_BANNER_KEYS = [DOWNTIME_BANNER_KEY];

let localStorage;

// block third party cookies check
// https://useloom.atlassian.net/browse/LOOM-1639
try {
  localStorage = window && window.localStorage;
} catch (err) {
  // do nothing
}

export const getDowntimeDateVal = () => {
  return moment().format(FORMAT_KEY);
};

export const checkHasSeenBannerToday = (key = DOWNTIME_BANNER_KEY) => {
  const storedDateVal = localStorage?.getItem(key);

  return storedDateVal === getDowntimeDateVal();
};

export const checkIsDismissed = (key = DOWNTIME_BANNER_KEY) => {
  const storedDateVal = localStorage?.getItem(key);

  return Boolean(storedDateVal);
};

export const PERMISSION_BANNER_SHARE_PAGE = 'sharePage';
export const PERMISSION_BANNER_LIBRARY = 'library';
export const PERMISSION_BANNER_DESTINATION = 'destination';
